import { useContext } from 'react';

import { AuthContext, type AuthContextValue } from './AuthContext';

/**
 * Hook to access the AuthContext.
 * Provides access to all auth, tenant, and account data.
 *
 * @throws Error if used outside of AuthContextProvider
 */
export function useAuthContext(): AuthContextValue {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthContextProvider');
  }
  return context;
}
